<template>
    <div class="header-body-container-forms">
        <div class="content-container">
            <div class="title-block">
                <h1 class="main-title">Say yes to the world!</h1>
                <img class="path-arrow" src="../../../assets/svgs/Path 20241.svg" />
                <h3 class="main-subtitle">
                    Find your flight and explore the world with us. We will take care of the rest.
                </h3>
            </div>
            <div class="content-form">
                <router-view />
            </div>
        </div>

        <div class="image-container">
            <img class="bottom-left-image" src="../../../assets/svgs/Group 7919.svg" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormsSection',
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/global-styles';

* {
    box-sizing: border-box;
}

.header-body-container-forms {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 50px;
    padding-top: 50px;

    .content-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;

        .title-block {
            position: relative;

            .path-arrow {
                position: absolute;
                z-index: 20;
                right: -20px;
                top: 75px;
            }

            .main-title {
                font-family: 'Poppins-Bold', sans-serif;
                font-size: 44px;
                line-height: 65px;
                color: $mainTextBlueColor;
                text-align: center;
                margin-bottom: 0;
            }

            .main-subtitle {
                font-family: 'Poppins-Regular', sans-serif;
                font-weight: lighter;
                font-size: 18px;
                line-height: 27px;
                text-align: left;
                color: $mainTextBlueColor;
                max-width: 408px;
                margin-top: 0;
            }
        }

        .content-form {
            width: 500px;
        }
    }

    .image-container {
        background: url('../../../assets/images/Header/pexels-gustavo-fring-4173229.png');
        width: 478px;
        height: 530px;
        border-radius: 200px 20px 20px 20px;
        background-position: -90px 0px;
        position: relative;

        .bottom-left-image {
            position: absolute;
            left: -30px;
            bottom: -30px;
        }
    }
}

@media (max-width: 1200px) {
    .header-body-container-forms {
        .content-container {
            .title-block {
                .path-arrow {
                    width: 23px;
                    top: 60px;
                    right: -5px;
                }

                .main-title {
                    font-size: 35px;
                    line-height: 50px;
                }

                .main-subtitle {
                    font-size: 14px;
                    line-height: 22px;
                    width: 95%;
                    padding-left: 10px;
                }
            }

            .content-form {
                width: 395px;
            }
        }

        .image-container {
            width: 378px;
            height: 420px;
            border-radius: 150px 20px 20px 20px;
        }
    }
}

@media (max-width: 992px) {
    .header-body-container-forms {
        padding: 0;
        padding-top: 50px;

        .content-container {
            .title-block {
                .path-arrow {
                    width: 17px;
                    top: 50px;
                    right: 45px;
                }

                .main-title {
                    font-size: 26px;
                    line-height: 37px;
                }

                .main-subtitle {
                    font-size: 10px;
                    line-height: 16px;
                    width: 80%;
                    padding-left: 60px;
                }
            }

            .content-form {
                width: 300px;
            }
        }

        .image-container {
            width: 286px;
            height: 318px;
            border-radius: 100px 20px 20px 20px;
            background-size: 596px 397px;
            background-position: -50px 0px;
        }
    }
}

@media (max-width: 768px) {
    .header-body-container-forms {
        padding: 0;
        padding-top: 50px;
        display: block;

        .content-container {
            .title-block {
                .path-arrow {
                    width: 29px;
                    top: 55px;
                    right: 0px;
                }

                .main-title {
                    font-size: 32px;
                    line-height: 48px;
                    padding-bottom: 10px;
                }

                .main-subtitle {
                    font-size: 14px;
                    line-height: 16px;
                    padding-left: 30px;
                    padding-bottom: 10px;
                }
            }

            .content-form {
                width: 353px;
            }
        }

        .image-container {
            display: none;
        }
    }
}

@media (max-width: 400px) {
    .header-body-container-forms {
        padding: 0;
        padding-top: 50px;
        display: block;

        .content-container {
            .title-block {
                .path-arrow {
                    width: 27px;
                    top: 55px;
                    right: 10px;
                }

                .main-title {
                    font-size: 30px;
                    line-height: 48px;
                    padding-bottom: 10px;
                }

                .main-subtitle {
                    font-size: 14px;
                    line-height: 16px;
                    padding-left: 20px;
                    padding-bottom: 10px;
                }
            }

            .content-form {
                width: 353px;
            }
        }

        .image-container {
            display: none;
        }
    }
}

@media (max-width: 350px) {
    .header-body-container-forms {
        padding: 0;
        padding-top: 50px;
        display: block;

        .content-container {
            .title-block {
                .path-arrow {
                    width: 25px;
                    top: 55px;
                    right: 10px;
                }

                .main-title {
                    font-size: 25px;
                    line-height: 40px;
                    padding-bottom: 10px;
                }

                .main-subtitle {
                    font-size: 10px;
                    line-height: 12px;
                    padding-left: 20px;
                    padding-bottom: 10px;
                }
            }

            .content-form {
                width: 300px;
            }
        }

        .image-container {
            display: none;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/FormsSection.vue